import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_2 = { style: {"margin":"-20px 0 -22px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "mb-4" }, "Credit Utilization Ratio", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "bar",
            height: "203",
            options: _ctx.creditUtilizationRatio,
            series: _ctx.ratio
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}